import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import constant from "../resources/constant";
import utils from "../resources/utils";

import en from "./en.json";
import id from "./id.json";

const resources = {
  en: { translation: en },
  id: { translation: id },
  in: { translation: id },
};

const getStoredLanguage = () => {
  try {
    const storedLang = utils._retrieveData(constant.SELECTED_LANGUAGE);
    if (storedLang && typeof storedLang === 'string') {
      return storedLang.split('-')[0];
    }
    if (storedLang && typeof storedLang === 'object' && storedLang.code) {
      return storedLang.code.split('-')[0];
    }
  } catch (error) {
    console.warn('Error retrieving stored language:', error);
  }
  return null;
};

export const initI18n = async () => {
  const detectedLanguage = getStoredLanguage() || 'en';
  await i18n.use(initReactI18next).init({
    resources,
    lng: detectedLanguage,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });
};

export default i18n;
